export default __webpack_public_path__ + "static/multimonthyear-1b6c84e43ff3a0efb5c96a891dbc0abc.png";